import { Container, Typography, Button, Box } from "@mui/material";

export function NothingFoundBackground() {
  return (
    <Container>
      <Typography variant="h1" align="center">
        Nothing to see here
      </Typography>

      <Typography variant="body1" align="center">
        Page you are trying to open does not exist. You may have mistyped the
        address, or the page has been moved to another URL. If you think this is
        an error contact support.
      </Typography>

      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Button component="a" href="/Home" size="md">
          Take me back to home page
        </Button>
      </Box>
    </Container>
  );
}
